module.exports = function() {
  return new Worker(__webpack_public_path__ + "605ab694b5dafb8e2182.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/worker-loader/dist/cjs.js!./src/store/modules/guided-analyses/betting-criteria.worker.js
// module id = UcXI
// module chunks = 0